// extracted by mini-css-extract-plugin
export var textInput = "_gw-0";